module.exports = __webpack_public_path__ + "img/halo.9fbb8542.svg";